<div>
  {{ lmService.sideNavToggle }}
  <div
    class="grabber {{ isRightBarExpanded ? 'z-index1' : 'z-index2' }}"
    [style.left]="
      isRightBarExpanded && lmService.sideNavToggle
        ? '567px'
        : !isRightBarExpanded && lmService.sideNavToggle
          ? '188px'
          : isRightBarExpanded
            ? '433px'
            : '55px'
    "
    pTooltip="{{ !isRightBarExpanded ? 'Open Automation' : 'Close Automation' }}"
    tooltipPosition="right"
    (click)="isRightBarExpanded = !isRightBarExpanded; LeftPanelExpanded.emit(isRightBarExpanded)">
    <i class="pi pi-chevron-{{ isRightBarExpanded ? 'left' : 'right' }} f-12"></i>
  </div>
  <div
    [id]="isRightBarView ? 'leftCardRightModule' : 'leftCard'"
    [ngClass]="{
      'left-collapsed': !isRightBarExpanded,
    }"
    [style.left]="lmService.sideNavToggle ? '204px' : '70px'">
    <div class="d-flex align-items-center justify-content-between my-1">
      <p class="workflow">Automations</p>
    </div>
    <ul class="nav nav-tabs" role="tablist">
      <li class="nav-item w-50" role="presentation">
        <button
          class="nav-link active w-100"
          id="workflow-tab"
          data-bs-toggle="tab"
          data-bs-target="#workflow"
          type="button"
          role="tab"
          aria-controls="workflow"
          aria-selected="true"
          (click)="onWorkflowChangeTab('workflow')">
          Workflows
          <i class="position-relative f-10 ml-2 pi {{ sortMenuLabel }}" (click)="Sortmenu.toggle($event)">
            <p-menu #Sortmenu [popup]="true" [model]="SortingMenu"></p-menu>
          </i>
        </button>
      </li>
      <li class="nav-item w-50" role="presentation">
        <button
          class="nav-link w-100"
          id="business_rules-tab"
          data-bs-toggle="tab"
          data-bs-target="#business_rules"
          type="button"
          role="tab"
          aria-controls="business_rules"
          aria-selected="false"
          (click)="onWorkflowChangeTab('business_rules')">
          Business Rules
          <i class="position-relative f-10 ml-2 pi {{ sortMenuLabel }}" (click)="Sortmenubusiness.toggle($event)">
            <p-menu #Sortmenubusiness [popup]="true" [model]="SortingMenu"></p-menu>
          </i>
        </button>
      </li>
    </ul>
    <div class="tab-content">
      <div *ngTemplateOutlet="recursiveTriggerList; context: { $implicit: triggerEvents, workflowtype: workflow_type }"></div>
    </div>
  </div>
</div>
<ng-template #recursiveTriggerList let-trigger let-workflowtype="workflowtype">
  <div
    class="tab-pane {{
      workflowtype === 'workflow' ? Sortmenu?.visible && 'position-relative' : Sortmenubusiness?.visible && 'position-relative'
    }} z-minus-1 active"
    [id]="workflowtype"
    role="tabpanel"
    [aria-labelledby]="workflowtype + '-tab'">
    <div class="position-relative my-2">
      <i class="pi pi-search search-Icon"></i>
      <input type="text" [(ngModel)]="search_keyword" (input)="FilterSearchTaskList()" placeholder="Search Automations" class="search-Input" />
    </div>
    <div class="d-flex justify-content-between">
      <ng-select
        [items]="_workflowService?.module_array"
        bindLabel="name"
        bindValue="module_value"
        [searchable]="true"
        [(ngModel)]="searchKeywordModule"
        #module="ngModel"
        placeholder="Search by Module"
        [clearable]="true"
        (change)="onChangeTriggerFilter()"
        class="archive-field mr-3 flex-grow-1 f-14"
        name="triger_module"
        id="triger_search"
        required>
        <ng-template ng-option-tmp let-item="item">
          <div>
            <span>{{ item.name }}</span>
          </div>
        </ng-template>
      </ng-select>
      <div>
        <button class="_addNew mr-2" (click)="triggerNull()">
          <i class="pi pi-plus f-14"></i>
        </button>
      </div>
    </div>
    <div class="w-100 h-100 d-flex align-items-center justify-content-center py-5 my-5" *ngIf="isLoad">
      <img [src]="common_images?.loading_state_gif" alt="" width="30px" />
    </div>
    <div class="position-relative">
      <ng-container *ngIf="triggerEvents?.length > 0">
        <div class="scroll_landing_page" (scroll)="onScroll($event)" #scrollableElement>
          <i class="pi pi-arrow-up scroll-top-icon" (click)="scrollToTop()" *ngIf="scrollTop > 50"></i>
          <div class="mt-2">
            <ul>
              <ng-container *ngFor="let action of trigger | searchFilter1: searchkeyword; let i = index">
                <li class="list" *ngIf="action.type === workflowtype" (click)="emitTriggerHandler(action)">
                  <ng-container *ngIf="action?.is_child_trigger; else no_child">
                    <div class="availability-status">
                      <i class="icon-child"></i>
                    </div>
                  </ng-container>
                  <ng-template #no_child>
                    <div class="availability-status">
                      <i class="icon {{ action?.canStart ? 'active' : 'inactive' }}"></i>
                    </div>
                  </ng-template>
                  <div
                    class="d-flex justify-content-center flex-column my-auto w-100 text-truncated mr-2"
                    pTooltip="{{ action.tigger_title }}"
                    tooltipPosition="top">
                    <p class="font-semibold text-truncated pr-1">{{ action.tigger_title }}</p>
                    <span class="f-10 mr-auto">{{ _workflowService.module_mapping[action.module] }}</span>
                  </div>
                  <small class="active-icon-circle">
                    <img
                      [src]="images?.pin_icon"
                      class="mr-2 {{ action?.pinned && 'pin-always' }} {{ !action?.pinned && 'unpin-svg' }}"
                      (click)="pinnedOrUnpinnedTrigger(action); updateTriggerId = action._id" />
                    <img [src]="images?.copy_icon" class="mr-2" (click)="cloneCopyTrigger($event, action); triggerDialog = false" />
                    <img [src]="common_images?.delete_icon" (click)="confirmDeleteTrigger(action)" />
                  </small>
                </li>
              </ng-container>
            </ul>
          </div>
        </div>
        <div class="mt-3">
          <p *ngIf="trigger?.length > 0">
            {{ 'Records: ' + Pagination?.total }}
          </p>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>

<!-- For New Trigger -->
<div class="triggerDialog">
  <p-dialog
    [header]="GetEditHeaderTitleForTrigger()"
    [(visible)]="triggerDialog"
    [modal]="true"
    [style]="{ width: '430px' }"
    [position]="'center'"
    [closable]="true"
    class="dialog-head"
    (onHide)="formTrigger?.resetForm({}); ProjectsUnits.selected = SpecificModuleListing = ProjectsUnits.allunits = []">
    <div>
      <form #formTrigger="ngForm">
        <div class="row mt-3">
          <div class="col-sm-12 form-group">
            <label for="tigger_title" class="trigger-label">Trigger Title</label>
            <input
              type="text"
              placeholder="e.g. New Lead"
              inputId="tigger_title"
              name="tigger_title"
              [(ngModel)]="flow.title"
              #title="ngModel"
              required />
            <span *ngIf="title?.invalid && (title?.dirty || title?.touched)" class="_required">
              <span *ngIf="title?.errors?.required"> Title is required </span>
            </span>
          </div>
          <div class="col-sm-12 form-group">
            <label for="tigger_des" class="trigger-label">Trigger Description</label>
            <textarea
              placeholder="e.g. When a New Lead is assigned"
              inputId="tigger_des"
              name="tigger_des"
              [(ngModel)]="flow.desc"
              #description="ngModel"
              class="text-area-style mb-1"></textarea>
          </div>
          <div class="col-sm-12 form-group">
            <label for="tigger_des" class="trigger-label">Trigger Module</label>
            <ng-select
              [items]="_workflowService?.module_array"
              bindLabel="name"
              bindValue="module_value"
              [searchable]="true"
              [(ngModel)]="flow.module"
              #module="ngModel"
              placeholder="Select Module"
              [clearable]="true"
              class="archive-field mb-1 f-14"
              name="triger_module"
              id="triger_module"
              required
              (change)="onChangeModule($event); flow.readonlyfilter = null">
              <ng-template ng-option-tmp let-item="item">
                <div>
                  <span>{{ item.name }}</span>
                </div>
              </ng-template>
            </ng-select>
            <span *ngIf="module?.invalid && (module?.dirty || module?.touched)" class="_required">
              <span *ngIf="module?.errors?.required"> Module is required </span>
            </span>
          </div>
          <div class="col-sm-12 form-group" *ngIf="ProjectsUnits?.allunits?.length > 0">
            <re-multiSelect
              [options]="ProjectsUnits?.allunits"
              [(selectedOptions)]="ProjectsUnits.selected"
              optionLabel="name"
              optionValue="_id"
              (onUpdate)="onChangeModule({ name: 'Specified Project Units' }, $event)"
              placeholder="Select lot">
            </re-multiSelect>
            <span *ngIf="projectunit?.invalid && (projectunit?.dirty || projectunit?.touched)" class="_required">
              <span *ngIf="projectunit?.errors?.required"> Module is required </span>
            </span>
          </div>
          <div class="col-sm-12 form-group" *ngIf="SpecificModuleListing?.length > 0">
            <re-multiSelect
              [options]="SpecificModuleListing"
              [(selectedOptions)]="flow.readonlyfilter"
              optionLabel="name"
              optionValue="_id"
              (onUpdate)="onChangeUnit($event)"
              placeholder="Select {{
                flow.module && ProjectsUnits?.allunits?.length == 0 ? _workflowService.GetAlteredModuleName(flow.module) : 'units'
              }}">
            </re-multiSelect>
            <span *ngIf="specifiedmodule?.invalid && (specifiedmodule?.dirty || specifiedmodule?.touched)" class="_required">
              <span *ngIf="specifiedmodule?.errors?.required"> Module is required </span>
            </span>
          </div>
          <div class="col-sm-12 form-group" *ngIf="excludeModuleListing?.length > 0">
            <re-multiSelect
              [options]="excludeModuleListing"
              [(selectedOptions)]="flow.exclude_records"
              optionLabel="name"
              optionValue="_id"
              (onUpdate)="onChangeUnit($event)"
              placeholder="Select Exclusions">
            </re-multiSelect>
            <span *ngIf="specifiedmodule?.invalid && (specifiedmodule?.dirty || specifiedmodule?.touched)" class="_required">
              <span *ngIf="specifiedmodule?.errors?.required"> Module is required </span>
            </span>
          </div>
          <div class="col-sm-12 form-group">
            <div class="d-flex align-items-center justify-content-between">
              <button (click)="show_icon = !show_icon" class="show-icon" title="Select Icon">{{ isIcon }}</button>
              <div *ngIf="display_icon" class="d-flex align-items-center">
                <i *ngIf="isSvg == false" class="{{ display_icon }} show-display-icon ml-3"></i>
                <img *ngIf="isSvg" class="show-display-icon ml-3 arr_icon_viewable" [src]="display_icon" />
              </div>
            </div>
            <div *ngIf="show_icon" class="flexo_">
              <ng-container *ngFor="let item of icon_array">
                <i class="{{ item.icon }} arr_icon" (click)="changeIconHandler(item.icon)"></i>
              </ng-container>
            </div>
          </div>
          <div class="col-sm-12 form-group">
            <label>Parent / Child</label>
            <div class="SP-switch">
              <p-inputSwitch [(ngModel)]="flow.is_child_trigger"></p-inputSwitch>
            </div>
          </div>
          <div class="col-sm-12 form-group" *ngIf="!flow.is_child_trigger && flow?.startoperationtime">
            <label class="trigger-label">Start when</label>
            <div *ngFor="let startwhen of _workflowService?.triggerStartList" class="p-field-checkbox d-flex">
              <p-checkbox
                name="leftstartingpoint"
                [(ngModel)]="flow.startoperationtime[startwhen.slug]"
                [value]="flow.startoperationtime[startwhen.slug]"
                [inputId]="'leftflow' + startwhen.id"
                [binary]="true">
              </p-checkbox>
              <label class="cursor-pointer f-12 font-weight-normal" [for]="'leftflow' + startwhen.id">&nbsp;{{ startwhen?.name }}</label>
            </div>
          </div>
        </div>
      </form>
      <div class="d-flex justify-content-center mb-3" *ngIf="!updateTriggerId">
        <button (click)="triggerPublish($event, null); triggerDialog = false" class="_primary-btn" [disabled]="formTrigger.invalid">Publish</button>
      </div>
      <div
        class="d-flex justify-content-{{ !isNewTrigger && (flow?.created_at || flow?.updated_at) ? 'between' : 'end' }} align-items-center mb-3"
        *ngIf="updateTriggerId"
        style="padding: 15px 33px">
        <div *ngIf="!isNewTrigger && (flow?.created_at || flow?.updated_at)">
          <label for="created_date" *ngIf="flow?.created_at" class="trigger-label f-12 d-block m-0"
            >Created
            <span class="font-weight-normal">{{ flow?.created_at | date: 'd MMMM y' }}</span>
          </label>
          <label for="created_date" *ngIf="flow?.updated_at" class="trigger-label f-12 d-block m-0"
            >Modified
            <span class="font-weight-normal">{{ flow?.updated_at | date: 'd MMMM y' }}</span>
          </label>
        </div>
        <button (click)="triggerEditPublish(formTrigger); triggerDialog = false" class="_primary-btn">Update</button>
      </div>
    </div>
  </p-dialog>
</div>
